import React, { useEffect, useState } from 'react';
import { Links } from '../../page_calculator/components/links';
import { Input } from '@chakra-ui/react';

export const DecathlonInputTable = () => {
  const GAS_URL =
    'https://script.google.com/macros/s/AKfycbxzmxuIS4acG3XXcFcdqKuJCr1ocL9M3IsE39PK_jc55AvJcICWbXnXnn4j4v-sp9Oa/exec';

  const [sheetData, setSheetData] = useState<any[][]>([]);

  const fetchSheet = async () => {
    const res = await fetch(GAS_URL);
    const data = await res.json();

    if (data.ok) {
      setSheetData(data.values);
    }
  };

  useEffect(() => {
    fetchSheet();
  }, []);

  const updateCell = async (
    rowIndex: number,
    colIndex: number,
    value: string
  ) => {
    await fetch(GAS_URL, {
      method: 'POST',
      body: JSON.stringify({
        token: 'test123',
        row: rowIndex + 1,
        col: colIndex + 1,
        value,
      }),
    });

    fetchSheet();
  };

  const eventNameMap: Record<string, string> = {
    name: '選手名',
    i00: '100m',
    lj: '走幅跳',
    sp: '砲丸投',
    hj: '走高跳',
    A00: '400m',
    ii0h: '110mH',
    dt: '円盤投',
    pv: '棒高跳',
    jt: 'やり投',
    i500: '1500m',
  };

  return (
    <>
      Input用のページ　男子
      <div
        style={{
          overflow: 'auto',
          // maxHeight: '80vh',
          width: '100%',
        }}
      >
        <table style={{ borderCollapse: 'collapse' }}>
          <tbody>
            {sheetData.map((row, rowIndex) => (
              <tr style={{ textAlign: 'center' }} key={rowIndex}>
                {row.map((cell, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      position:
                        rowIndex === 0 || colIndex === 0 ? 'sticky' : 'static',
                      top: rowIndex === 0 ? 0 : undefined,
                      left: colIndex === 0 ? 0 : undefined,
                      background: '#fff',
                      zIndex:
                        rowIndex === 0 && colIndex === 0
                          ? 4
                          : rowIndex === 0
                          ? 3
                          : colIndex === 0
                          ? 2
                          : 1,
                      minWidth: colIndex === 0 ? '100px' : '80px',
                      width: colIndex === 0 ? '100px' : '80px',
                      border: '1px solid #ddd',
                      padding: '4px',
                    }}
                  >
                    {rowIndex === 0 ? (
                      eventNameMap[String(cell)] ?? cell
                    ) : colIndex === 0 ? (
                      (() => {
                        const [name, ...team] = String(cell).split('-');

                        return (
                          <>
                            <div
                              style={{
                                fontWeight: 'bold',
                                textAlign: 'center',
                              }}
                            >
                              {name}
                            </div>
                            <div
                              style={{
                                fontSize: '8px',
                                color: '#666',
                                textAlign: 'center',
                              }}
                            >
                              {team.join('-')}
                            </div>
                          </>
                        );
                      })()
                    ) : (
                      <Input
                        defaultValue={cell}
                        list="record-options"
                        size="sm"
                        width="70px"
                        inputMode="numeric"
                        type="text"
                        textAlign="center"
                        onBlur={(e) =>
                          updateCell(rowIndex, colIndex, e.target.value)
                        }
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <datalist id="record-options">
          <option value="DNS" />
          <option value="DNF" />
          <option value="NM" />
          <option value="DQ" />
        </datalist>
      </div>
      <Links />
    </>
  );
};
